import React, { useCallback, useMemo, useState } from 'react'
import {
    DataGrid,
    GridColDef,
    GridActionsCellItem,
    GridRowId,
    GridRowParams,
    GridToolbarContainer,
    esES,
    GridValueGetterParams
} from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import moment from 'moment';
import { TimerHandler } from './TimerHandler';
import { Button } from '@mui/material';

const TimerTable = (props: ITimerTableProps) => {
    const { data: rows, onChange } = props;
    const [open, setOpen] = useState(false);
    const [rowIdSelected, setRowIdSelected] = useState<GridRowId | undefined>(undefined);

    const itemSelected = useMemo(() => {
        const item = rows.find(item => item.id === rowIdSelected);
        if (item !== undefined) return item;
    }, [rowIdSelected, rows]);

    const editTimer = useCallback(
        (id: GridRowId) => () => {
            setOpen(true);
            setRowIdSelected(id);
        },
        [rows],
    );

    const deleteTimer = useCallback(
        (id: GridRowId) => () => {
            setTimeout(() => {
                onChange(rows.filter((row) => row.id !== id));
            });
        },
        [rows, onChange],
    );


    const columns: GridColDef[] = useMemo(() => [
        {
            field: 'discountPercent',
            headerName: 'Descuento',
            width: 100,
            sortable: false,
            editable: false,
            valueGetter: (params: GridValueGetterParams<ITimer>) => {
                let value = params.row.discountPercent;
                return `${value}%`;
            },
        },
        {
            field: 'activationFrom',
            headerName: 'Inicio',
            width: 150,
            sortable: false,
            editable: false,
            valueGetter: (params: GridValueGetterParams<ITimer>) => {
                let value = params.row.activation.dateFrom;
                return moment(value).format('DD/MM/YY HH:mm');
            },
        },
        {
            field: 'activationTo',
            headerName: 'Fin',
            width: 150,
            sortable: false,
            editable: false,
            valueGetter: (params: GridValueGetterParams<ITimer>) => {
                let value = params.row.activation.dateTo;
                return moment(value).format('DD/MM/YY HH:mm');
            },
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Opciones',
            width: 100,
            sortable: false,
            editable: false,
            getActions: (params: GridRowParams) => [
                <GridActionsCellItem icon={<EditIcon />} label="Editar" onClick={editTimer(params.id)} />,
                <GridActionsCellItem icon={<DeleteIcon />} label="Eliminar" onClick={deleteTimer(params.id)} />,
            ]
        },
    ], [editTimer, deleteTimer]);

    return (
        <>
            <DataGrid
                localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                autoHeight
                slots={{
                    toolbar: () => (
                        <GridToolbarContainer>
                            <Button
                                color="primary"
                                startIcon={<AddIcon />}
                                onClick={() => {
                                    setOpen(true);
                                    setRowIdSelected(undefined);
                                }}>
                                Agregar temporizador
                            </Button>
                        </GridToolbarContainer>
                    )
                }}
                rowSelection={false}
                columns={columns}
                rows={rows}
            />
            <TimerHandler
                type={rowIdSelected !== undefined ? 'EDIT' : 'NEW'}
                open={open}
                payload={itemSelected}
                onSubmit={(payload) => {
                    const _rows = [...rows];
                    const index = _rows.findIndex(item => item.id === payload.id);
                    if (index !== -1) _rows[index] = payload;
                    else _rows.push(payload);

                    onChange(_rows);
                }}
                onClose={() => { 
                    setOpen(false);
                    setRowIdSelected(undefined);
                }}
            />
        </>
    );

};

export { TimerTable };